import { render, staticRenderFns } from "./historyAction.vue?vue&type=template&id=653aba8e&scoped=true"
import script from "./historyAction.vue?vue&type=script&lang=js"
export * from "./historyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653aba8e",
  null
  
)

export default component.exports